export default "__VITE_ASSET__FJoPPTy5__"